/**
 * @param {Error} error
 *
 * @return {string}
 * */
export default function parseErrorMessage({ message }) {
  try {
    return JSON.parse(message).message;
  } catch {
    return message;
  }
}
